import React, { useCallback, useEffect } from 'react';
import Checkbox from '../../../forms/CheckBox';
import { useReframe } from 'nike-re-framejs';
import { makeField, PostProcessor } from 'nike-form-js';
import Input from '../../../forms/Input';
import PathError from '../../../forms/PathError';

function OptionMulti({ form, question, option }) {
    const path = [question.type, question.id, option.id, 'checkbox'];
    const { deref } = useReframe();
    const field = makeField(form, path);
    const fieldValue = deref(field.getValue());
    const isTouched = PostProcessor.isTouchedField(form.deref(), path);

    const initAndTouchCheckboxOnForm = useCallback(value => field.setValue(value), [field]);
    useEffect(() => {
        if (!isTouched) {
            initAndTouchCheckboxOnForm(false);
        }
    }, [isTouched, initAndTouchCheckboxOnForm]);

    return (
        <div key={option.id}>
            <label className="nike-input" htmlFor={path}>
                <Checkbox form={form} path={path}>
                    <span className="kyc-answer-label fs-16 c-black-100">{option.label}</span>
                </Checkbox>
            </label>
            {option.children.map(children =>
                fieldValue ? (
                    <FreeText key={children.id} form={form} question={question} option={option} children={children} />
                ) : null
            )}
        </div>
    );
}

function FreeText({ form, question, option, children }) {
    const path = [question.type, question.id, option.id, option.type, children.id];
    const field = makeField(form, path);
    const isTouched = PostProcessor.isTouchedField(form.deref(), path);

    const initAndTouchFreeTextOnForm = useCallback(value => field.setValue(value), [field]);
    useEffect(() => {
        if (!isTouched) {
            initAndTouchFreeTextOnForm(null);
        }
    }, [isTouched, initAndTouchFreeTextOnForm]);

    return (
        <Input
            type="textarea"
            form={form}
            id={'freetext' + option.id}
            name={'freetext'}
            path={path}
            placeholder={children.label}
            rows="3"
            className="nui-textarea"
            maxLength="250"
        />
    );
}

function KycQuestionMulti({ form, question }) {
    if (!question) {
        return null;
    }

    return (
        <>
            <h1 className="kyc-list-title mt-20 mb-15 fs-16 text-extra-bold">{question.label}</h1>
            {question.option.map(option => (
                <OptionMulti key={option.id} question={question} option={option} form={form} />
            ))}
            <PathError form={form} path={[question.type, question.id]} />
        </>
    );
}

export default KycQuestionMulti;
